/**
 * Utility function to open Tawktrik chat widget
 */
export const openTawktrikChat = () => {
  try {
    if (window.cd360Api && window.cd360Api.liveChat) {
      window.cd360Api.liveChat.showWebWidget();
    } else if (typeof window.OpenChatWidget === 'function') {
      window.OpenChatWidget();
    } else {
      console.warn('Tawktrik chat widget not loaded yet');
    }
  } catch (error) {
    console.error('Error opening Tawktrik chat:', error);
  }
};
